module.exports = __webpack_public_path__ + "img/icon-image.59b81cce.svg";